import useLogger from "../hooks/useLogger.js";
const fetchData = (getToken) => async ({
  uri,
  method,
  params = null
}) => {
  const logger = useLogger("fetchData");
  const accessToken = getToken?.();
  if (!accessToken) {
    logger.error("Access token is undefined");
    throw null;
  }
  try {
    if (!uri) {
      logger.error("endpoint URI is undefined");
      throw null;
    }
    const response = await fetch(uri, {
      method: method || "GET",
      headers: {
        Authorization: `${accessToken}`,
        "Content-Type": "application/json"
      },
      ...method && method === "POST" ? {
        body: JSON.stringify(params)
      } : {}
    });
    if (!response.ok) {
      logger.error("Error fetching data:", response.statusText);
      throw null;
    }
    const data = await response.json();
    if (data instanceof Error) {
      logger.error("Error parsing data:", {
        data
      });
      throw null;
    }
    return data;
  } catch (error) {
    logger.error("Error fetching data:", error);
    throw null;
  }
};
export {
  fetchData as default
};
